export type UnitName =
  | "sec"
  | "min"
  | "heure"
  | "centiemes"
  | "€"
  | "€/h"
  | "€/m3"
  | "€/m2"
  | "€/m"
  | "€/tonne"
  | "€/kg"
  | "%"
  | "jours"
  | "mm"
  | "mm/min"
  | "mm/s"
  | "m/min"
  | "m2"
  | "plis/min"
  | "plis/h"
  | "coups/min";

export const unitMap: Record<UnitName, string> = {
  sec: "secondes",
  min: "min",
  heure: "heures",
  centiemes: "centièmes",
  "€": "€",
  "€/m3": "€/m3",
  "€/m2": "€/m2",
  "€/m": "€/m",
  "€/tonne": "€/tonne",
  "€/kg": "€/kg",
  "€/h": "€/h",
  "%": "%",
  jours: "jours",
  mm: "mm",
  "mm/min": "mm/min",
  "mm/s": "mm/s",
  "m/min": "m/min",
  m2: "m2",
  "plis/min": "plis/min",
  "plis/h": "plis/h",
  "coups/min": "coups/min",
};

export type Factor = { value: number; unit: UnitName | undefined };

export const isValidUnitFactor = (
  unit: string | null | undefined,
  validUnitFactors: Factor[],
): unit is UnitName => {
  return validUnitFactors.some((factor) => factor.unit === unit);
};
